<!-- <template>
  <div v-if="isdeleteUserModalOpen" class="modal-container">
    <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>
    <div class="modal-content w-[550px] relative bg-white w-full max-w-md m-auto flex-col flex rounded-lg">
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark">
          Are you sure you want to delete <span class="font-bold">{{ selectedUser.first_name }} {{ selectedUser.last_name }}</span>?
        </h2>
      </div>

      <form @submit.prevent="deleteUser" class="overflow-y-auto px-6">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">
            To confirm, type "delete" in the box below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type delete"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <div class="flex justify-end gap-4 mb-4">
					<p type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" @click="$emit('close')">Cancel</p>
					<button
						type="submit"
						:class="[
							'py-2 px-4 w-[146px] h-[42px] text-white rounded',
							confirmationText === 'delete' ? 'bg-red-500 hover:bg-red-600' : 'bg-gray-300 cursor-not-allowed'
						]"
						:disabled="confirmationText !== 'delete'"
					>
						Delete user
					</button>

        </div>
      </form>
    </div>
  </div>
</template> -->

<template>
  <div v-if="isdeleteUserModalOpen" class="modal-container">
    <div
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
    ></div>
    <div
      class="modal-content w-[550px] relative bg-white w-full max-w-md m-auto flex-col flex rounded-lg"
    >
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark">
          <span v-if="mode === 'user'">
            Are you sure you want to delete
            <span class="font-bold"
              >{{ selectedUser.first_name }} {{ selectedUser.last_name }}</span
            >?
          </span>
          <span v-else-if="mode === 'role'">
            Are you sure you want to remove the
            <span class="font-bold">{{ roleToRemove }}</span> role from
            <span class="font-bold"
              >{{ selectedUser.first_name }} {{ selectedUser.last_name }}</span
            >?
          </span>
        </h2>
      </div>
      <form @submit.prevent="handleSubmit" class="overflow-y-auto px-6">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">
            <span v-if="mode === 'user'"
              >To confirm, type "delete" in the box below</span
            >
            <span v-else-if="mode === 'role'"
              >To confirm, type "remove" in the box below</span
            >
          </label>
          <input
            type="text"
            v-model="confirmationText"
            :placeholder="mode === 'user' ? 'Type delete' : 'Type remove'"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
        <div class="flex justify-end gap-4 mb-4">
          <button
            type="button"
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'py-2 px-4 w-[146px] h-[42px] text-white rounded',
              isConfirmationValid
                ? 'bg-red-500 hover:bg-red-600'
                : 'bg-gray-300 cursor-not-allowed',
            ]"
            :disabled="!isConfirmationValid"
          >
            {{ mode === "user" ? "Delete user" : "Remove role" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";


export default {
  name: "DeleteUserModal",
  components: {},
  props: {
    selectedUser: {
      type: Object,
      required: true,
    },
    isdeleteUserModalOpen: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      default: "user", // 'user' or 'role'
      validator: (value) => ["user", "role"].includes(value),
    },
    roleToRemove: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      confirmationText: "", // Input for "delete"
      showError: false,
    };
  },
    computed: {
    isConfirmationValid() {
      if (this.mode === 'user') {
        return this.confirmationText === 'delete';
      } else if (this.mode === 'role') {
        return this.confirmationText === 'remove';
      }
      return false;
    }
  },

  methods: {
        async handleSubmit() {
      if (this.mode === 'user') {
        await this.deleteUser();
      } else if (this.mode === 'role') {
        await this.removeRole();
      }
    },

    // async deleteUser() {
    //   this.showError = false;
    //   this.errorMessage = "";
    //   try {
    //     await apiClient.delete(`/web/users/${this.selectedUser.user_id}`);
    //     console.log(`User ${this.selectedUser.user_id} deleted successfully.`);
    //     this.$emit("userDeleted", "User deleted successfully"); // Emit success message
    //     this.$emit("refresh"); // Trigger parent to refresh users
    //     this.$emit("close"); // Close the modal
    //   } catch (error) {
    //     console.error("Error deleting user:", error);
    //   }
    // },
   
       async deleteUser() {
      try {
        await apiClient.delete(`/web/users/${this.selectedUser.user_id}`);
        console.log(`User ${this.selectedUser.user_id} deleted successfully.`);
        this.$toast.success('User deleted successfully');
        this.$emit('userDeleted', 'User deleted successfully');
        this.$emit('refresh');
        this.$emit('close');
      } catch (error) {
        console.error('Error deleting user:', error);
        this.$toast.error('Failed to delete user');
      }
    },
    async removeRole() {
      try {
        await apiClient.post('/web/profile/deactivate', {
          user_id: this.selectedUser.user_id,
          profile: this.roleToRemove,
        });
        
        this.$toast.success(`${this.roleToRemove} role removed successfully`);
        this.$emit('roleRemoved', `${this.roleToRemove} role removed successfully`);
        this.$emit('refresh');
        this.$emit('close');
      } catch (error) {
        console.error('Error removing role:', error);
        this.$toast.error('Failed to remove role');
      }
    },
      
    handleUserDeleted(message) {
      this.$toast.success(message);
    },
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>
